export const clearLocalStorageItemsFromExtensions = (): void => {
  /*
   * extension: flow-editor
   * feat: copy and paste widgets
   * use case: a copied widget should be available until the user does a logout/login
   * Why here: cannot listen to logout/login events in the extensions
   * */
  localStorage.removeItem('flow-copy-and-paste');
};
